import { useEffect, useState } from 'react'
import LandingPage from './components/LandingPage'
import PresentationMode from './components/PresentationMode'
import { LanguageProvider } from './contexts/LanguageContext'
import './styles/App.css'

function App() {
  const [startInPresentationMode, setStartInPresentationMode] = useState(false);

  useEffect(() => {
    // Check URL for presentation parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('presentation') === 'true') {
      setStartInPresentationMode(true);
      // Clean up URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  if (startInPresentationMode) {
    return (
      <LanguageProvider>
        <PresentationMode onExit={() => setStartInPresentationMode(false)} />
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
      <div className="App">
        <div className="parallax-bg"></div>
        <div id="landing-page-container">
          <LandingPage />
        </div>
      </div>
    </LanguageProvider>
  )
}

export default App
